import { render, staticRenderFns } from "./CertifikatPredogled.vue?vue&type=template&id=3cb53ff7&scoped=true&"
import script from "./CertifikatPredogled.vue?vue&type=script&lang=js&"
export * from "./CertifikatPredogled.vue?vue&type=script&lang=js&"
import style0 from "./CertifikatPredogled.vue?vue&type=style&index=0&id=3cb53ff7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb53ff7",
  null
  
)

export default component.exports